import { z } from 'zod';

/**
 * Bootstrap data emitted by `page_calendar.php` on the FullCalendar v7 path,
 * read once from a `<script type="application/json" data-view-data-page-calendar>`
 * element (the SearchPage pattern).
 */
export const pageCalendarBootstrapSchema = z.object({
    /** Resolved CalApiID — the id the `/api/calendars/{id}/events` endpoint expects. */
    calendarApiId: z.number(),
    isMealCalendar: z.boolean(),
    /** v3 `default_view`: 'calendar' | 'list' | 'meal_calendar'. */
    defaultView: z.string(),
    /** v3 `default_date_view`: 'month' | 'agendaWeek' | 'agendaDay'. */
    defaultDateView: z.string(),
    accessibility: z.boolean(),
    /** Deep link `?view=` (only 'day' is accepted by the v3 validator). */
    deepLinkView: z.string().nullable(),
    /** Deep link `?date=` (YYYY-MM-DD). */
    deepLinkDate: z.string().nullable(),
});

export type PageCalendarBootstrap = z.infer<typeof pageCalendarBootstrapSchema>;
